import React, {Component} from 'react';
import '../../styles/Home.css'
import QRCode from 'qrcode.react';
import * as acc from "accounting";
import {Button} from "react-bootstrap";
import KoszykService from "../KoszykService";
import AppConfig from "../../AppConfig";
import ReactTooltip from "react-tooltip";
import {NotificationManager} from "react-notifications";

export default class Realizacja extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bilety: [],
            transakcja: this.props.bilety[0].platnosciTransakcja
        }
    }

    componentDidMount() {
        KoszykService.getTransakcja(this.props.bilety[0].platnosciTransakcja).then(function (response) {
            this.setState({bilety: response.data})
        }.bind(this))
        // KoszykService.getPotwierdzenie(this.props.bilety[0].platnosciTransakcja).then(function (response) {
        // }.bind(this))

    }

    anulujBilet(item) {
        this.setState({loading: true});
        KoszykService.putAnulujTransakcje(item.idBi, this.props.bilety[0].platnosciTransakcja).then(function (response) {
            this.componentDidMount();
            NotificationManager.warning("", "Bilet został anulowany ", 5000);
        }.bind(this))
    }

    checkStatus(status) {
        if (status === -1) {
            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>DO OPŁACENIA</span>
        } else {
            if (status === 0) {
                return <span style={{fontWeight: 'bold', background: '#17a2b8', color: 'white', borderRadius: 5, padding: '4px 8px'}}>REZERWACJA</span>
            } else {
                if (status === 1) {
                    return <span style={{fontWeight: 'bold', background: '#57b13c', color: 'white', borderRadius: 5, padding: '4px 8px'}}>OPŁACONY</span>
                } else {
                    if (status === 2) {
                        return <span style={{fontWeight: 'bold', background: '#ffa707', color: 'white', borderRadius: 5, padding: '4px 8px'}}>SKASOWANY</span>
                    } else {
                        if (status === -2 || status === -3) {
                            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ANULOWANO</span>
                        } else {
                            if (status === -4) {
                                return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ZWRÓCONO</span>
                            } else {
                                if (status === -5) {
                                    return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>NIEOPŁACONY</span>
                                } else {
                                    if (status === -6) {
                                        return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>PŁAT. ZWRÓCONA</span>
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    checkAnulowany() {
        let bool = false;
        for (let i = 0; i < this.state.bilety.length; i++) {
            if (this.state.bilety[i].statPoz === -2) {
                bool = true;
            }
        }
        return bool;
    }

    checkWazny(item) {
        return <div><i className="fa fa-calendar"
                       style={{paddingLeft: 2, paddingRight: 2, color: '#696969'}}></i> {item.waznyDo}</div>
    }

    checkWaznyCzas(item) {
        return <div><i className="fa fa-clock-o"
                       style={{paddingLeft: 10, paddingRight: 2, color: '#696969'}}></i>{item.godz}</div>
    }

    render() {
        return <div className="container">

            <hr/>
            <div className="rezerwacjaPomyslnie" id='divToPrint'>
                <h2><i
                    className="fa fa-2x fa-check"> </i> {this.props.bilety[0].statBil !== -1 ? 'Rezerwacja przebiegła' : 'Zakup przebiegł'} pomyślnie
                </h2>
                <h5 style={{
                    fontWeight: 400,
                    paddingBottom: 0
                }}>Dane {this.props.bilety[0].statBil !== -1 ? 'rezerwacji' : 'zakupu'} oraz bilety zostały wysłane na
                    adres
                    e-mail: <b>{this.props.email}</b></h5>
                <h5>Twoja rezerwacja: </h5>
                {this.state.bilety.map((item, index) => {
                    return <div
                        className={"wynik"} style={{margin: 10}}>
                        <div key={"kurs" + item.idKu} id={"bilet" + item.idBi}
                             style={{marginLeft: 5, marginRight: 5}}
                             className={"row"}>
                            <div className="col-sm-2">
                                <QRCode value={item.idBi.toString()} size={120}/>
                                <div className="czas" style={{paddingTop: 8}}>ID: <b>{item.idBi}</b>
                                </div>
                            </div>
                            <div className="col-sm-10">
                                <div className="row">
                                    <div className="col-sm-1"
                                         style={{
                                             textAlign: 'right',
                                             paddingLeft: 0,
                                             paddingRight: 0,
                                             maxWidth: 30
                                         }}>
                                        <div className="godzinaOdjazd"><i
                                            className="fa fa-arrow-right"
                                            style={{fontSize: '1.25rem', paddingTop: 0}}> </i>
                                        </div>
                                        <div className="godzinaPrzyjazd"><i
                                            className="fa fa-arrow-left"
                                            style={{fontSize: '1.25rem', paddingTop: 0, color: '#eeb207'}}> </i></div>
                                    </div>
                                    <div className="col-sm-5 text-left"
                                         style={{paddingLeft: 15, paddingRight: 5}}>
                                        <div className="miejsceOdjazd">{item.nazMiOd}
                                            <span> {item.nazPrOd}</span></div>
                                        <div className="miejscePrzyjazd">{item.nazMiDo}
                                            <span> {item.nazPrDo}</span></div>
                                    </div>
                                    <div className="col-sm-4" style={{textAlign: 'left'}}>
                                        <div className="row">
                                            <div
                                                className="czas col-6"
                                                style={{paddingTop: 8}}><b>{this.checkWazny(item)}</b>
                                            </div>
                                            <div
                                                className="czas col-6"
                                                style={{paddingTop: 8}}><b>{this.checkWaznyCzas(item)}</b>
                                            </div>
                                        </div>
                                        <div
                                            className="czas"
                                            style={{paddingTop: 8}}>Klient: <b>{item.klient}</b></div>
                                    </div>
                                    <div className="col-sm-2"
                                         style={{
                                             paddingLeft: 0,
                                             paddingRight: 0,
                                             textAlign: 'left'
                                         }}>
                                        <div className="czas" style={{paddingTop: 8}}>Typ: <b>{item.nazZniz}</b>
                                        </div>
                                        <div
                                            className="cenaNormalny"
                                            style={{paddingTop: 8}}>Cena: <span>{acc.formatMoney(item.cena, {
                                            symbol: "zł",
                                            format: "%v %s"
                                        })}</span></div>
                                    </div>
                                </div>
                                {item.statPoz === -2 ?
                                    <div className="row" style={{paddingRight: 25, paddingTop: 15}}>
                                        <div className="col-sm-6"/>
                                        <div className="col-sm-6 text-center">
                                            <span style={{color: 'red'}}>BILET ANULOWANY</span>
                                        </div>
                                    </div>
                                    :
                                    <div className="row" style={{paddingRight: 25, paddingTop: 15}}>
                                        <div className="col-sm-6">
                                            &nbsp;
                                        </div>
                                        <div className="col-sm-2 text-right">
                                            <a href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + this.props.bilety[0].platnosciTransakcja + AppConfig.V_LOG()}><Button
                                                bsStyle="success" bsSize="small"><i
                                                className="fa fa-download"
                                                style={{
                                                    color: 'white',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    paddingLeft: 5,
                                                    paddingRight: 5
                                                }}
                                                aria-hidden="true"> </i>Pobierz
                                                bilet</Button></a>
                                        </div>
                                        <div className="col-sm-2 text-center">
                                            <a target="_blank"
                                               href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + this.props.bilety[0].platnosciTransakcja + '?download=false'  + AppConfig.V_LOG_SECOND_PARAM()}>
                                                <Button bsStyle="info" bsSize="small"><i
                                                    className="fa fa-print"
                                                    style={{
                                                        color: 'white',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                        paddingLeft: 5,
                                                        paddingRight: 5
                                                    }}
                                                    aria-hidden="true"> </i>Drukuj bilet</Button></a>
                                        </div>
                                        <div className="col-sm-2 text-left">
                                            <ReactTooltip id={(item.idKu + 123456).toString()}>
                                                <div className="text-left">
                                                    Aby anulować pozycję należy anulować cały bilet o ID: {item.idBi}
                                                </div>
                                            </ReactTooltip>
                                            {item.statPoz === -2 ? null : <div>
                                                {index > 0 && this.state.bilety[index - 1].idBi === item.idBi ?
                                                    <div data-tip data-for={(item.idKu + 123456).toString()}
                                                         data-place="bottom"><Button bsStyle={"disabled"}
                                                                                     disabled={true} bsSize="small"
                                                                                     onClick={() => this.anulujBilet(item)}><i
                                                        className="fa fa-times"
                                                        style={{
                                                            color: 'white',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            paddingLeft: 2,
                                                            paddingRight: 2
                                                        }}
                                                        aria-hidden="true"> </i>Anuluj</Button></div> :
                                                    <Button bsStyle="danger" bsSize="small"
                                                            onClick={() => this.anulujBilet(item)}><i
                                                        className="fa fa-times"
                                                        style={{
                                                            color: 'white',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            paddingLeft: 2,
                                                            paddingRight: 2
                                                        }}
                                                        aria-hidden="true"> </i>Anuluj</Button>
                                                }</div>}
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })
                }
                {this.checkAnulowany() ? null :
                    <div className="row">
                        <div className="col-sm-6 text-right">
                            <a href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/transakcja/' + this.props.bilety[0].platnosciTransakcja + AppConfig.V_LOG()}><Button
                                bsStyle="success"><i className="fa fa-download" style={{color: 'white'}}
                                                     aria-hidden="true"> </i>Pobierz wszystkie bilety</Button></a>
                        </div>
                        <div className="col-sm-6 text-left">
                            <a target="_blank"
                               href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/transakcja/' + this.props.bilety[0].platnosciTransakcja + '?download=false' + AppConfig.V_LOG_SECOND_PARAM()}><Button
                                bsStyle="info"><i className="fa fa-print" style={{color: 'white'}}
                                                  aria-hidden="true"> </i>Drukuj
                                wszystkie bilety</Button></a>
                        </div>
                    </div>}
                <div style={{paddingTop: 10}}>
                    <b>UWAGA! Na przystanku należy pojawić się co najmniej 15 minut przed odjazdem.</b>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/Realizacja.js